<template>
    <div class="record dsp-record">
        <ul>
            <li>
                <div class="key"> School District </div>
                <div class="value singleline">  <a :href="dsp.allSchoolUrl" class="link" target="_blank" rel="nofollow"> {{getSchoolDistrict}} </a> </div>
            </li>
            <li>
                <div class="key"> Grade </div>
                <div class="value singleline"> {{dsp.level}} </div>
            </li>
            <li v-if="dsp.districtName">
                <div class="key"> Teacher/Student Ratio </div>
                <div class="value singleline"> {{dsp.tsRatio}} </div>
            </li>
            <li>
                <div class="key"> Type </div>
                <div class="value singleline capitalize"> {{dsp.type}} </div>
            </li>
        </ul>
    </div>
</template>
<script src="./dsp-record.js"></script>
<style lang="scss">
@use "./dsp-record.scss" as *;
</style>